/** @flow @format */
import { makeAutoObservable } from "mobx";
import WebFont from "webfontloader";

import type { Font, FontProvider, FontFamily } from "../types";

export default class FontModel {
  fontProvider: FontProvider;
  fontFamily: FontFamily;
  isLoading: boolean = false;
  isLoaded: boolean = false;
  couldNotLoad: boolean = false;

  constructor(font: Font) {
    this.fontProvider = font.fontProvider;
    this.fontFamily = font.fontFamily;
    makeAutoObservable(this);
  }

  handleLoading = () => {
    this.isLoading = true;
    this.isLoaded = false;
    this.couldNotLoad = false;
  };

  handleActive = () => {
    this.isLoading = false;
    this.isLoaded = true;
    this.couldNotLoad = false;
  };
  handleInactive = () => {
    this.isLoading = false;
    this.isLoaded = false;
    this.couldNotLoad = true;
  };

  handleFontLoading = (familyName: string, fontVariation: string) => {};

  handleFontActive = (familyName: string, fontVariation: string) => {};

  handleFontInactive = (familyName: string, fontVariation: string) => {};

  load = async () => {
    if (this.isLoaded) {
      return;
    }

    const WebFontConfig = {
      loading: this.handleLoading,
      active: this.handleActive,
      inactive: this.handleInactive,
      fontloading: this.handleFontLoading,
      fontactive: this.handleFontActive,
      fontinactive: this.handleFontInactive,
      [this.fontProvider]: {
        families: [this.fontFamily],
      },
    };

    WebFont.load(WebFontConfig);
  };
}
